export const createAsyncOnce = <T>(operation: () => Promise<T>) => {
  let inFlight: Promise<T> | null = null
  return (): Promise<T> => {
    if (!inFlight) {
      inFlight = operation().catch((error) => {
        inFlight = null
        throw error
      })
    }
    return inFlight
  }
}

export const createKeyedAsyncOnce = <T>(operation: (key: string) => Promise<T>) => {
  let current: { key: string; promise: Promise<T> } | null = null
  return (key: string): Promise<T> => {
    if (current?.key === key) return current.promise
    const promise = operation(key).catch((error) => {
      if (current?.promise === promise) current = null
      throw error
    })
    current = { key, promise }
    return promise
  }
}
